import useSwr from "@/core/composables/swr/useSwr";
import {notificationSequenceApi} from "@/container";
import {
    NotificationSequenceMessageInstanceIndexRequest
} from "@/core/http/resources/notification-sequence/NotificationSequenceResource";
import {NotificationSequenceMessageInstanceStatus} from "@/notification-sequences/interfaces/NotificationSequence";
import {computed} from "vue";
import {cacheKey} from "@/lib/cache";
import dayjs from "dayjs";

/** How many days back a message skipped for lack of credit stays listed. */
const NO_CREDIT_WINDOW_IN_DAYS = 30;

/**
 * Filters for the messages skipped for lack of credit over the rolling window.
 * Day-truncated so the cache key stays stable across views mounted the same day.
 */
export const noCreditMessageInstanceFilters = (): Pick<NotificationSequenceMessageInstanceIndexRequest, 'status' | 'updated_since'> => ({
    status: NotificationSequenceMessageInstanceStatus.NO_CREDIT,
    updated_since: dayjs().subtract(NO_CREDIT_WINDOW_IN_DAYS, 'day').format('YYYY-MM-DD')
});

const useNotificationSequenceMessageInstances = (params: NotificationSequenceMessageInstanceIndexRequest = {}) => {
    const key = computed(() => {
        return cacheKey('notification-sequence-message-instances', params);
    });

    return useSwr(
        key,
        () => notificationSequenceApi().messageInstancesIndex(params),
    );
};

export default useNotificationSequenceMessageInstances;
